import { render, staticRenderFns } from "./DNAChampionHeatmap.vue?vue&type=template&id=61013ad8"
import script from "./DNAChampionHeatmap.vue?vue&type=script&lang=js"
export * from "./DNAChampionHeatmap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports